<template>
  <div>
    <!-- {{file_repository_id}} -->
    <div v-if="isBrowseContent">
      <vs-popup fullscreen title="" :active.sync="isBrowseContent">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
        ></import-browse-files-model>
      </vs-popup>
    </div>
    <vs-button
      style="display: inline-flex; float: left"
      class="mb-2"
      color="primary"
      type="filled"
      icon="menu"
      @click.prevent="switchTheme"
    >
      <span v-if="theme != 'list'">List View</span>
      <span v-if="theme == 'list'">Grid View</span>
    </vs-button>
    <!-- <vs-tooltip
      text="Import File From Your Existing System"
      style="display: inline-flex; float: right"
    >
      <vs-button
        class="mb-2 ml-2"
        color="primary"
        type="filled"
        icon="file_upload"
        @click="isBrowseContent = true"
        >Files</vs-button
      >
    </vs-tooltip> -->

    <!-- <vs-button
      style="display: inline-flex; float: right"
      class="mb-2"
      color="dark"
      type="filled"
      icon="close"
      @click.prevent="hideFileUploader"
    >
    </vs-button> -->

    <vs-divider />
    <!-- {{accept}} -->
    <VueFileAgent
      ref="vueFileAgent"
      :accept="accept"
      :auto="auto"
      :theme="theme"
      :multiple="true"
      :deletable="false"
      :meta="true"
      :readonly="true"
      :maxSize="'10000MB'"
      :maxFiles="14"
      :helpText="helpText"
      :errorText="{
        type: 'Invalid file type. Only images or zip Allowed',
        size: 'Files should not exceed 10MB in size',
      }"
      @beforedelete="onBeforeDelete($event)"
      @delete="fileDeleted($event)"
      v-model="fileRecords"
      @upload:error="uploadEvent('upload:error', $event)"
    ></VueFileAgent>

    <div v-if="fileRecordsForUpload.length">
      <vs-divider />
      <vs-button
        :disabled="!fileRecordsForUpload.length"
        @click="uploadFiles()"
      >
        Upload {{ fileRecordsForUpload.length }} files
      </vs-button>
    </div>

    <vs-divider />
  </div>
</template>

<script>
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel'

import { getUploadedFilesId } from '@/api/assignment-question'

export default {
  name: 'VueFileAgentComponent',
  components: { ImportBrowseFilesModel },
  props: {
    question_detail_obj: {},
    question_detail_index: {},
    acceptedfileUploadType: {},
    helpText: {},

    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    },
    filesInfo: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isBrowseContent: false,
      theme: 'grid',
      auto: true,
      fileRecords: [],
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [], // maintain an upload queue
      accept: ''
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  created () {
    if (this.filesInfo.length) {


      this.fileRecords = this.filesInfo.map((ele) => {
        return {
          name: ele.file.file_name,
          sizeText: this.bytesToSize(ele.file.size),
          size: ele.file.size,
          type: ele.file.file_type,
          url: ele.file.file_path,
          upload: {
            data: true,
            error: false
          }
        }
      })
      // this.accept = this.acceptedfileUploadType

    }
    //
    const customer_id = this.$store.getters.customerId
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
  },
  mounted () {
    setTimeout(() => {
      this.accept = this.acceptedfileUploadType
    }, 1000)
  },
  methods: {
    hideFileUploader () {
      this.$emit('hideFileUploader')
    },
    switchTheme () {
      this.theme = this.theme === 'list' ? 'default' : 'list'
    },
    uploadEvent (eventName, data) {

    },
    uploadFiles () {


      // Using the default uploader. You may use another uploader instead.
      // const data = this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload)

      //

      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {


          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )


      this.$vs.loading({
        type: 'material',
        text: 'Please wait we are uploading files'
      })

      data
        .then((response, error) => {

          const cdn = response[0].data.data.cdn
          if (response) {
            for (let i = 0; i < response.length; i++) {
              const file_name = response[i].data.data.files[0].file_name
              const file_path = response[i].data.data.files[0].file_path




              const raw = JSON.stringify({
                file_repository_id: this.file_repository_id,
                files: [
                  {
                    file_name,
                    file_path: `${cdn}${file_path}`
                  }
                ]
              })

              const file_id_payload = raw

              this.getUploadFiles(file_id_payload)
            }
          } else {

            this.$vs.loading.close()
          }
        })
        .catch((error) => {
          this.$vs.loading.close()


        })
        .finally(this.$vs.loading.close())
      this.fileRecordsForUpload = []
    },

    filesSelected (fileRecordsNewlySelected) {

      const validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      )

      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      )
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this file?',
          accept: this.acceptAlert,
          parameters: fileRecord
        })
      }
    },
    acceptAlert (fileRecord) {
      const index = this.fileRecords.indexOf(fileRecord)

      this.deletedIndex = index


      this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event

      // this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    },
    deleteUploadedFile (fileRecord) {

      const fileIdObject = {
        question_detail_index: this.question_detail_index,
        fileIndex: this.deletedIndex
      }
      this.$emit('deletedIndex', fileIdObject)

    },

    //custom function for getting upload file

    async getUploadFiles (file_id_payload) {
      const res = await getUploadedFilesId(file_id_payload)

      if (res.data.message === 'files.createFile') {
        const file_id = res.data.data.files[0].files_id
        this.$vs.notify({
          title: 'Success',
          text: 'File uploaded successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })


        const fileIdObject = {
          question_index: this.question_detail_index,
          file_id
        }

        this.$vs.loading.close()

        this.$emit('getFileId', fileIdObject)
      }
    },
    getImportFile ({ file_id, fileInfo }) {

      const fileObject = {
        question_index: this.question_detail_index,
        file_id
      }
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)

      const importFileRecords = this.getImportedFile(fileInfo)

      this.filesInfo.push(
        ...importFileRecords.map((ele) => {
          return {
            file: {
              file_name: ele.name,
              file_path: ele.url,
              size: ele.size,
              file_type: ele.type
            }
          }
        })
      )

      this.fileRecords.push(...importFileRecords)
      this.$emit('getFileId', fileObject)
    },
    getImportedFile (fileInfo) {
      return fileInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          color: 'green',
          upload: {
            data: true,
            error: false
          }
        }
      })
    }

    //custom function for getting upload files
  }
}
</script>
